import type { Guild } from '../types';
import { apiClient } from './client';

export const guildsApi = {
  getGuilds: async (): Promise<Guild[]> => {
    const response = await apiClient.get<Guild[]>('/guilds');
    return response.data;
  },
};
